import type { UserProfile, AuthTokens, AuthResponse } from '../types/models.js'
import { ApiError } from '../types/api.js'

const API = '/api/v1/auth'

async function apiPostAuth<T>(path: string, body?: unknown, useAuth?: boolean): Promise<T> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  if (useAuth) {
    const token = localStorage.getItem('mf_access')
    if (token) headers['Authorization'] = `Bearer ${token}`
  }
  const res = await fetch(path, { method: 'POST', headers, body: body !== undefined ? JSON.stringify(body) : undefined })
  if (!res.ok) {
    const b = await res.json()
    const err = b?.error ?? { code: 'UNKNOWN', message: `Request failed (${res.status})` }
    throw new ApiError(res.status, err)
  }
  if (res.status === 204) return null as any
  const b = await res.json()
  return b.data
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  return apiPostAuth(`${API}/login`, { email, password })
}

export async function register(data: {
  email: string
  password: string
  firstName?: string
  lastName?: string
}): Promise<AuthResponse> {
  return apiPostAuth(`${API}/register`, data)
}

export async function refresh(token: string): Promise<AuthTokens> {
  return apiPostAuth(`${API}/refresh`, { refreshToken: token })
}

export async function loadMe(): Promise<UserProfile> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const token = localStorage.getItem('mf_access')
  if (token) headers['Authorization'] = `Bearer ${token}`
  const res = await fetch(`${API}/me`, { headers })
  if (!res.ok) {
    const b = await res.json()
    const err = b?.error ?? { code: 'UNKNOWN', message: 'Failed to load profile' }
    throw new ApiError(res.status, err)
  }
  const b = await res.json()
  return b.data
}

export async function logout(): Promise<void> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' }
  const token = localStorage.getItem('mf_access')
  if (token) headers['Authorization'] = `Bearer ${token}`
  await fetch(`${API}/logout`, { method: 'POST', headers })
}